import type { DocumentRecord } from "../../types/record";

interface RagResultCardProps {
  document?: DocumentRecord;
  remainingCount?: number;
  onClick?: () => void;
}

export function RagResultCard({
  document,
  remainingCount,
  onClick,
}: RagResultCardProps) {
  if (remainingCount !== undefined) {
    return (
      <div
        onClick={onClick}
        className="h-32 w-full bg-white/5 backdrop-blur-sm rounded-lg p-2 overflow-hidden hover:bg-white/10 transition-colors flex items-center justify-center cursor-pointer"
      >
        <p className="text-sm text-white/90 font-medium">
          +{remainingCount} documents
        </p>
      </div>
    );
  }

  if (!document) return null;

  // Calculate relevance percentage from the score
  const relevancePercentage = Math.min(
    100,
    Math.round((document.score || 0) * 100)
  );

  return (
    <div
      onClick={onClick}
      className="h-32 w-full bg-white/5 backdrop-blur-sm rounded-lg p-2 overflow-hidden hover:bg-white/10 transition-colors cursor-pointer"
    >
      <div className="flex flex-col h-full">
        <div className="text-[10px] text-white/50 text-left">
          Document {document.id}
        </div>
        <div className="flex-1 flex items-center">
          <p className="text-xs text-white/90 font-medium line-clamp-3 text-left w-full">
            {document.title}
          </p>
        </div>
        <div className="flex items-center justify-between">
          <div className="text-[10px] text-white/50 text-left">Relevance:</div>
          <div className="rounded px-1.5 py-0.5 bg-white/10 text-[10px] font-medium">
            {relevancePercentage}% match
          </div>
        </div>
      </div>
    </div>
  );
}
